module Client.Admin.ManageNews.Delete

open Client
open Shared
open Illy.SafeStack.Client
open Fable.React
open Shared.Admin.ManageNews
open Shared.Admin.ManageNews.Delete

type Model = 
    {
        NewsArticleId: NewsArticleId
        Saving: bool
    }

type Msg = 
    | SaveResult of FailureReason option
    | ApiError of ApiError
    | DeleteClicked
    | CloseOverlay

type Event = 
    | CloseOverlay 
    | DeleteSuccessful of notification: string
    | ApiError of ApiError 

let init newsArticleId = 
    {
        NewsArticleId = newsArticleId
        Saving = false
    }, []

let update model msg = 
    match msg with 
    | Msg.ApiError err -> model, err |> ApiError |> SideEffect.Event 
    | Msg.CloseOverlay -> model, CloseOverlay |> SideEffect.Event
    | DeleteClicked -> 
        {model with Saving = true},
        Api.secureCall<IManageNewsApi,_,_,_> SecuredRoute.Admin (fun api -> api.deleteArticle) model.NewsArticleId SaveResult Msg.ApiError
        |> SideEffect.Cmd
    | SaveResult reason ->
        match reason with 
        | None 
        | Some NothingToDo -> 
            model, "News Article was deleted successfully." |> Event.DeleteSuccessful |> SideEffect.Event

let view model dispatch = 
    jQueryUI.modal "Delete News Article" 50 Msg.CloseOverlay dispatch (Some 800) [
        str "Are you sure you want to delete this News Article? Once this is deleted the action cannot be undone."
        yield! UI.saveControls (Some "Delete") false model.Saving DeleteClicked Msg.CloseOverlay dispatch
    ]